import { cloneDeep } from "lodash";
import { DatapointIdStandardEnum } from "api/ux/src";
export const getMutableComponentProps = (componentProps, originalComponentProps) => {
    if (componentProps !== originalComponentProps) {
        // Already cloned
        return componentProps;
    }
    return cloneDeep(componentProps);
};
export const collectAllMeasures = (componentProps) => {
    const measures = componentProps.datapointParams?.flatMap((p) => p.measures || []) || [];
    if (componentProps.dataSelectProps?.length) {
        const dataSelectMesures = componentProps.dataSelectProps.flatMap((d) => Object.values(d.selectValues)
            .flatMap((v) => v.datapointParams?.flatMap((p) => p.measures || []) || []));
        measures.push(...dataSelectMesures);
    }
    const switcher = componentProps?.gridSwitcher;
    if (switcher) {
        const gridSwitcherMeasures = collectAllMeasures(switcher);
        if (gridSwitcherMeasures.length) {
            measures.push(...gridSwitcherMeasures);
        }
    }
    return measures;
};
const removeMeasuresInComponentProps = (predicate, datapointParams) => {
    const deleted = [];
    const formulas = [];
    for (const params of datapointParams || []) {
        for (const datapoint of params || []) {
            const toRemove = datapoint.measures?.filter(predicate) || [];
            for (const measure of toRemove) {
                datapoint.measures?.splice(datapoint.measures?.indexOf(measure) ?? -1, 1);
                deleted.push(measure);
            }
            formulas.push(...datapoint.measures?.filter((m) => m.standardDatapoint === DatapointIdStandardEnum.DatapointFormula)
                .map((m) => ({ measure: m, source: datapoint })) || []);
        }
    }
    const formulasToDelete = formulas.filter((f) => deleted.some((d) => d.name === f.measure.context?.formula?.left || d.name === f.measure.context?.formula?.right));
    for (const formula of formulasToDelete) {
        formula.source.measures?.splice(formula.source.measures?.indexOf(formula.measure) ?? -1, 1);
    }
};
export const removeMeasures = (componentProps, filter) => {
    const allParams = [componentProps.datapointParams];
    if (componentProps.dataSelectProps?.length) {
        for (const dataSelect of componentProps.dataSelectProps) {
            for (const value of Object.values(dataSelect.selectValues)) {
                allParams.push(value.datapointParams);
            }
        }
    }
    removeMeasuresInComponentProps(filter, allParams);
    const switcher = componentProps?.gridSwitcher;
    if (switcher) {
        removeMeasures(switcher, filter);
    }
};
